module.exports = __webpack_public_path__ + "img/testimoni-ibu-irma-safari.5ed39a34.jpeg";